var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "assistantCenter" }, [
    _c("div", { staticClass: "assistantCenter_page" }, [
      _c("div", { staticClass: "assistantCenter-nav" }, [
        _c(
          "div",
          { staticClass: "assistantCenter-nav-list" },
          _vm._l(_vm.navList, function (item) {
            return _c(
              "div",
              {
                key: item.value,
                staticClass: "assistantCenter-nav-list-view",
                class: { navActive: _vm.active === item.value },
                on: {
                  click: function ($event) {
                    return _vm.onChangeNav(item)
                  },
                },
              },
              [_c("div", [_vm._v(_vm._s(item.label))])]
            )
          }),
          0
        ),
      ]),
      _c(
        "div",
        { staticClass: "assistantCenter-content" },
        [
          _c(_vm.active, {
            tag: "components",
            on: {
              editAi: (item) => _vm.$emit("editAi", item),
              onAdd: _vm.onhandleAdd,
              openAi: (id) => _vm.$emit("openAi", id),
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }